import { useTranslation } from 'react-i18next';

export const keyPrefix = 'top_match_card_info';
export const useTopMatchCardInfoTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    tag: 'Карточка',
    fio: 'ФИО',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    tag: 'Card',
    fio: 'Full name',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    tag: 'Cartão',
    fio: 'Nome completo',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    tag: 'Tarjeta',
    fio: 'Nombre completo',
  },
}) as Record<string, unknown>;
